// 防检测工具：UA/环境过滤 + 伪合规
// 返回 true 表示放行，false 表示拦截（显示无害内容）

const BLOCKED_UAS = [
  /headless/i, /phantom/i, /selenium/i, /puppeteer/i, /playwright/i,
  /bot/i, /crawler/i, /spider/i, /slurp/i, /scan/i, /curl/i, /wget/i,
];

export const isBlocked = () => {
  try {
    const ua = navigator.userAgent || '';
    // 爬虫/自动化 UA
    if (BLOCKED_UAS.some((r) => r.test(ua))) return true;
    // headless 环境特征
    if (navigator.webdriver) return true;
    if (!window.chrome || !navigator.languages || !navigator.languages.length) return true;
    // 无头浏览器的插件/语言特征
    if (navigator.languages[0] === '' || !navigator.plugins) return true;
    return false;
  } catch (e) {
    return true; // 异常环境一律拦截
  }
};

// 无害落地内容（被拦截时显示）
export const renderBlocked = () => {
  document.body.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#f5f5f7;font-family:-apple-system,BlinkMacSystemFont,sans-serif;">
      <div style="text-align:center;color:#1d1d1f;">
        <div style="font-size:48px;margin-bottom:12px;">🚀</div>
        <h1 style="font-size:24px;font-weight:700;margin:0 0 8px;">Coming Soon</h1>
        <p style="font-size:14px;color:#6e6e73;">Our service is under maintenance. Please check back later.</p>
      </div>
    </div>`;
};
